export class DialogAddFileData {
	public constructor(
		public folderViewId: number,
		public folderId: string
	) {}
}
